import * as React from 'react';

interface ControlProps {
    total: number,
    perPage: number,
    currentPage: number,
    onSelect: (event: React.ChangeEvent<HTMLSelectElement>) => void,
    orderBy: string,
}

export const ResultControls: React.SFC<ControlProps> = ({total, currentPage, perPage, onSelect, orderBy}) => {

    const fromX = () => {
        // return (currentPage - 1) * perPage + 1;
        return 1;
    }

    const toY = () => {
        const to = currentPage * perPage;
        return to >= total ? total : to;
    }

    const orderOptions = [
        {
            value: 'relevance',
            label: 'Relevance',
        },
        {
            value: 'date-desc',
            label: 'Most Recent First',
        },
        {
            value: 'date-asc',
            label: 'Oldest First',
        },
    ];

    return (
        <div className="search__result-controls">
            <div className="search__result-controls__col">

                <span> {fromX()} - {toY()} of {total} results</span>
            </div>
            <div className="search__result-controls__col layout__med-col-right">
                <label>Sort by:</label>
                <div className="search__filter__orderby-container">
                    <select className="search__filter-orderby" onChange={onSelect}>
                        { orderOptions.map( ({label, value}) => (
                            <option value={value} selected={orderBy === value}>{label}</option>
                        ))}
                    </select>

                    <svg width="9px" height="6px" viewBox="0 0 9 6" version="1.1">
                        <g id="Search---Articles" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Articles-Search---2400" transform="translate(-1468.000000, -206.000000)" fill="#8F8F8F" fill-rule="nonzero">
                                <polygon id="Triangle-Copy" transform="translate(1472.500000, 209.000000) rotate(-180.000000) translate(-1472.500000, -209.000000) " points="1472.5 206 1477 212 1468 212"></polygon>
                            </g>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    )
}
